import { useState, useEffect } from 'preact/hooks';
import './ProductComparisonSummary.less';
import { apiClient } from '../../services/ApiClient';
import Icon from '../../components/icon/Icon';
import ProductsComparisonTable from '../../components/main/comparison/ProductsComparisonTable';
import { ProductComparisonResult } from '@public-api-contracts/models/assistant/ProductComparisonTable';
import useAppDispatch from '../../hooks/useAppDispatch';

export type ProductComparisonSummaryProps = {
    quantityVisible?: number;
    productIds: string[];
    title: string;
};

const ProductComparisonSummary = ({
    quantityVisible = 4,
    productIds,
    title
}: ProductComparisonSummaryProps) => {
    const dispatch = useAppDispatch();
    const [table, setTable] = useState<ProductComparisonResult | null>(null);

    useEffect(() => {
        const result = apiClient.assistant.productComparisonTable({
            body: { productIds, fillWithSimilarUntil: quantityVisible }
        });
        result
            .then(response => {
                if (response.products.length === quantityVisible) {
                    setTable(response);
                }
            })
            .catch(() => {});
    }, [quantityVisible]);
    if (!table) {
        return null;
    }
    return (
        <div className={`bri-ProductComparisonSummary`}>
            <div className="bri-ProductComparisonSummary-header">
                <div className="bri-ProductComparisonSummary-title bri-TitleBoldFont">
                    <Icon iconId="brilliant-logo" />
                    {title}
                </div>
            </div>
            <div className="bri-ProductComparisonSummary-items">
                <ProductsComparisonTable
                    groups={table.groups}
                    products={table.products}
                    suggestedProductsQuantity={
                        quantityVisible - productIds.length
                    }
                    onAddProductToCart={product =>
                        dispatch.featureState.startFeature({
                            featureType: 'product-detail',
                            productId: product.productId,
                            product,
                            source: 'web'
                        })
                    }
                    minSectionsToShow={quantityVisible}
                    showExpandButtons={false}
                    expandAllGroups
                />
            </div>
        </div>
    );
};

export default ProductComparisonSummary;
